import { useEffect, useState } from 'react';

export const useElementWidth = (
  containerRef: React.RefObject<HTMLElement | null>,
) => {
  const [availableWidth, setAvailableWidth] = useState<number>(0);

  useEffect(() => {
    const element = containerRef.current;

    const setWidth = () => {
      const width = containerRef.current?.offsetWidth;
      if (width && width !== availableWidth) {
        setAvailableWidth(width);
      }
    };

    setWidth();

    if (element) {
      const observer = new ResizeObserver(setWidth);
      observer.observe(element);
      return () => observer.unobserve(element);
    }
  }, [availableWidth, containerRef]);

  return availableWidth;
};
